<template>
	<div class="FAQ">
		<div class="container">
			<h1>{{ $t('navigationFAQ.title') }}</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<div>
						{{ $t('navigationFAQ.description') }}
						<router-link :to="{ name: 'Kontakt' }">zum Kontakt</router-link>
					</div>
				</div>
				<div class="py-5 col-9">
					<div class="mb-5">
						<h4 class="mb-3">{{ $t('navigationFAQ.question1.question') }}</h4>
						<ul>
							<li class="mb-3">
								{{ $t('navigationFAQ.question1.answer.absatz1') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question1.answer.absatz2') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question1.answer.absatz3') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question1.answer.absatz4a') }}
								<router-link :to="{ name: 'BasicQualificationCourse' }">{{
									$t('navigationFAQ.question1.answer.absatz4b')
								}}</router-link>
								{{ $t('navigationFAQ.question1.answer.absatz4c') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question1.answer.absatz5') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question1.answer.absatz6') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question1.answer.absatz7') }}
								{{ $t('navigationFAQ.question1.answer.absatz8') }}
								{{ $t('navigationFAQ.question1.answer.absatz9') }}
								{{ $t('navigationFAQ.question1.answer.absatz10') }}
							</li>
						</ul>
					</div>
					<div class="mb-5">
						<h4 class="mb-3">{{ $t('navigationFAQ.question2.question') }}</h4>
						<div class="mb-3">
							{{ $t('navigationFAQ.question2.answer.absatz1') }}
						</div>
					</div>
					<div class="mb-5">
						<h4 class="mb-3">{{ $t('navigationFAQ.question3.question') }}</h4>
						<div class="mb-3">
							{{ $t('navigationFAQ.question3.answer.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question3.answer.absatz2') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question3.answer.absatz3') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question3.answer.absatz4') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question3.answer.absatz5') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question3.answer.absatz6') }}
						</div>
					</div>
					<div class="mb-5">
						<h4 class="mb-3">{{ $t('navigationFAQ.question4.question') }}</h4>
						<div class="mb-3">
							{{ $t('navigationFAQ.question4.answer.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question4.answer.absatz2') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question4.answer.absatz3') }}
						</div>
						<div class="Zitat mb-1">
							{{ $t('navigationFAQ.question4.answer.absatz4') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationFAQ.question4.answer.absatz5') }}
						</div>
					</div>
					<div class="mb-5">
						<h4 class="mb-3">{{ $t('navigationFAQ.question5.question') }}</h4>
						<div class="mb-3">
							{{ $t('navigationFAQ.question5.answer.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question5.answer.absatz2') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question5.answer.absatz3') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question5.answer.absatz4') }}
						</div>
					</div>
					<div class="mb-5">
						<h4 class="mb-3">{{ $t('navigationFAQ.question6.question') }}</h4>
						<div class="mb-3">
							{{ $t('navigationFAQ.question6.answer.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question6.answer.absatz1a') }}
						</div>
						<ul class="noBulletPoints">
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz6') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz7') }}
								<a href="tel: 09251 8998639">09251 8998639</a>
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz8') }}
								<a href="mailto: info@sos-p.com">info@sos-p.com</a>
							</li>
							<li class="mb-3">
								<a target="_blank" href="https://sos-p.com">www.sos-p.com</a>
							</li>
						</ul>
						<div class="UnterUeberschrift mb-3">
							{{ $t('navigationFAQ.question6.answer.absatz9') }}
						</div>
						<ul class="noBulletPoints">
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz10') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz11') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz12') }}
								<a href="tel: 0176 27054406">0176 27054406</a>
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz13') }}
								<a href="mailto: info@selfprotection.de"
									>info@selfprotection.de</a
								>
							</li>
							<li class="mb-3">
								<a target="_blank" href="http://selfprotection.de"
									>www.selfprotection.de</a
								>
							</li>
						</ul>
						<div class="UnterUeberschrift mb-3">
							{{ $t('navigationFAQ.question6.answer.absatz15') }}
						</div>
						<ul class="noBulletPoints">
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz16') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz17') }}
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz18') }}
								<a href="tel: 0151 18401734">0151 18401734</a>
							</li>
							<li class="mb-3">
								{{ $t('navigationFAQ.question6.answer.absatz19') }}
								<a href="mailto: info@matac.net">info@matac.net</a>
							</li>
							<li class="mb-3">
								<a target="_blank" href="https://matac.net">www.matac.net</a>
							</li>
						</ul>
					</div>
					<div class="mb-5">
						<h4 class="mb-3">{{ $t('navigationFAQ.question7.question') }}</h4>
						<div class="mb-3">
							{{ $t('navigationFAQ.question7.answer.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question7.answer.absatz2') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question7.answer.absatz3') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question7.answer.absatz4') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question7.answer.absatz5') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationFAQ.question7.answer.absatz6') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FAQ',
	i18n: {
		messages: {
			de: require('@/i18n/de/de_faq.json'),
			en: require('@/i18n/en/eng_faq.json')
		}
	}
}
</script>

<style scoped lang="stylus">
.noBulletPoints {
	list-style: none;
}

a {
	color: red;
}
</style>
